
// =============================================================================
// models/commerce/Variant.js - PRODUCTION READY
// =============================================================================

import { Model } from 'pinia-orm';
import Product from '@/models/commerce/Product.js';

export default class Variant extends Model {
  static entity = 'variants';

  static fields() {
    return {
      id: this.uid(),
      productId: this.attr(''),
      name: this.attr(''),
      price: this.attr(0),
      stock: this.attr(100),
      avatarUrl: this.attr(''),

      // «تدبيسة» pieces of THIS size still on the shelf (BE→FE brief
      // 2026-09-22, VariantResource). Always sent, 0 on an ordinary variant.
      // Declared or pinia-orm's $fill drops it — the size sheet's per-size cap
      // (utils/tadbeesa.js resaleLineCap) and the row's "left" count read it.
      resaleAvailableQty: this.number(0),

      // Relationship
      product: this.belongsTo(Product, 'productId'),
    };
  }

  // ==========================================================================
  // BUSINESS LOGIC
  // ==========================================================================

  /**
     * Check if variant is available
     */
  get isAvailable() {
    return this.stock > 0;
  }

  /**
     * Get formatted price
     */
  get formattedPrice() {
    return `${(this.price / 100).toFixed(2)} EGP`;
  }

  /**
     * Get stock status
     */
  get stockStatus() {
    if (this.stock === 0) return 'out_of_stock';
    if (this.stock < 10) return 'low_stock';
    return 'in_stock';
  }
}
